import { getUTCDate } from '@/utils/getUTCDate'
import { DaySlotSchedule } from '../scheduled-types'

export class ProfessionalScheduleMapper {
  toDomain(data: DaySlotSchedule) {
    return {
      date: getUTCDate(data?.date),
      slots: data?.schedules?.map(slot => {
        return {
          id: slot.id,
          time: slot.time,
        }
      }),
    }
  }
}

export default new ProfessionalScheduleMapper()
